export interface PopupResult<TResult> {
	readonly isCanceled: boolean;
	readonly result?: TResult;
}

export interface IPopupContext<TResult> {
	closePopup(result: TResult): void;
	cancelPopup(result: TResult): void;
}

export interface IPopupViewModel<TResult> {
	/**
	 * Used by the host app to map to a concrete UI component.
	 */
	readonly popupId: string;

	/**
	 * Called by the host when the popup is shown.
	 * The view model must store the context and use it to close/cancel the popup.
	 */
	init(context: IPopupContext<TResult>): void;
}

/**
 * Generic UI popup abstraction (implemented by the host app, faked in tests).
 */
export abstract class IPopupService {
	/**
	 * The host app should render this view model (e.g. via a `PopupViewer`).
	 */
	abstract get currentPopup(): IPopupViewModel<unknown> | null;

	abstract showPopup<TResult>(model: IPopupViewModel<TResult>): Promise<PopupResult<TResult>>;
}


